/**
 * Массовая правка прокси (D29): что форма показывает при выбранном типе, то и уходит на сервер.
 *
 * Keep-Alive и gzip — у HTTP-прокси, UDP — у SOCKS5. Форма прячет поле, которого выбранный тип не несёт, и
 * спрятанное не уходит, даже если его выставили до смены типа. Тип «не изменять» (выборка бывает смешанной)
 * показывает все три.
 */

/** Какие из полей, зависящих от типа, форма показывает; `undefined` — тип «не изменять». */
export const bulkFieldsShownForType = (proxyType) => {
  const typeKept = proxyType === undefined || proxyType === null || proxyType === '';
  return {
    is_keepalive: proxyType !== 'socks5',
    is_compression: proxyType !== 'socks5',
    is_udp_enabled: typeKept || proxyType === 'socks5',
  };
};

/** Значения формы без полей, которые выбранный тип прячет. */
export const withoutFieldsHiddenByType = (values) => {
  const shown = bulkFieldsShownForType(values?.proxy_type);
  return Object.fromEntries(
    Object.entries(values || {}).filter(([field]) => shown[field] !== false),
  );
};
